import axiosPrivate from "../../../api/axiosPrivate";
import {
  CREATE_COMMISSION,
  CREATE_SEGMENTED_COMMISSION,
  GET_ALL_COMMISSIONS,
  GET_SINGLE_COMMISSION,
  UPDATE_DIRECT_COMMISSION,
  UPDATE_SEGMENTED_COMMISSION,
} from "../../../api/constant";

// Create direct commissions
const createCommission = async (clauseData) => {
  const response = await axiosPrivate.post(CREATE_COMMISSION, clauseData);
  return response.data;
};

// Create direct commissions
const createSegmentedCommission = async (clauseData) => {
  const response = await axiosPrivate.post(
    CREATE_SEGMENTED_COMMISSION,
    clauseData
  );
  return response.data;
};

// Get all commissions
const getAllCommissions = async (pageNumber) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_COMMISSIONS}?page=${pageNumber}`
  );
  return response.data;
};
// Get single commission
const getSingleCommission = async (id) => {
  const response = await axiosPrivate.get(`${GET_SINGLE_COMMISSION}/${id}`);
  return response.data;
};
// Update direct commission
const updateDirctCommission = async (data) => {
  const response = await axiosPrivate.post(
    `${UPDATE_DIRECT_COMMISSION}/${data.id}`,
    data
  );
  return response.data;
};
// Update Segmented commission
const updateSegmentedCommission = async (data) => {
  const response = await axiosPrivate.post(
    `${UPDATE_SEGMENTED_COMMISSION}/${data.id}`,
    data
  );
  return response.data;
};

const commissionService = {
  createCommission,
  createSegmentedCommission,
  getAllCommissions,
  getSingleCommission,
  updateDirctCommission,
  updateSegmentedCommission,
};

export default commissionService;
